export default __webpack_public_path__ + "static/media/waves.0a13457a.svg";